import { css, html, LitElement } from 'lit';
import { ToujouStorageBehaviour } from '../../../mixins/toujou-storage-behaviour.js';

class ToujouFavCount extends ToujouStorageBehaviour(LitElement) {
  static get is() {
    return 'toujou-fav-count';
  }

  static get properties() {
    return {
      favCount: {
        type: Number,
        attribute: 'fav-count',
        reflect: true,
      },
    };
  }

  static get styles() {
    return css`
      .count-wrapper {
        position: relative;
        display: flex;
        flex-direction: row-reverse;
      }

      .count {
        background-color: var(
          --toujou-fav-count-background-color,
          var(--error-color)
        );
        height: var(--toujou-fav-count-size, 16px);
        width: var(--toujou-fav-count-size, 16px);
        font-size: var(--toujou-fav-count-font-size, 12px);
        color: var(--toujou-fav-count-font-color, white);
        border-radius: var(--toujou-fav-count-border-radius, 50%);
        display: var(--toujou-fav-count-display, flex);
        align-items: var(--toujou-fav-count-align-items, center);
        justify-content: var(--toujou-fav-count-justify-content, center);
        position: var(--toujou-fav-count-position, relative);
        top: var(--toujou-fav-count-top, 0);
        left: var(--toujou-fav-count-left, 0);
      }
    `;
  }

  constructor() {
    super();
    this.favCount = 0;
  }

  render() {
    return html`
      <slot name="icon"></slot>
      <div class="count-wrapper" part="count-wrapper">
        <div class="count" part="count">${this.favCount}</div>
      </div>
      <slot></slot>
    `;
  }

  set storageValue(favList) {
    this.favCount = (favList || []).length;
  }
}

customElements.define(ToujouFavCount.is, ToujouFavCount);
